import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameFormater',
  standalone: true,
})
export class NameFormaterPipe implements PipeTransform {
  transform(value: string, ...args: string[]): string {
    const firstnameSplited = value.split(' ')
    const lastnameSplited = args[0].split(' ')

    if(lastnameSplited[1]){
      lastnameSplited[1] = lastnameSplited[1][0] + '.'
    }

    return `${firstnameSplited[0]} ${lastnameSplited.join(' ')}`;
  }
}
